<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card payment-card text-main-black">
        <dialog-show-receipt
          v-if="showReceiptDialog"
          :showDialog="showReceiptDialog"
          :isPDF="isPDF"
          :receiptUrl="currentReceipt"
          @closeDialog="closeReceiptDialog"
        />
        <dialog-to-payment
          v-if="showPaymentDialog"
          :showDialog="showPaymentDialog"
          :payment="currentPayment"
          @closeDialog="closePaymentDialog"
        />

        <md-card-content class="mobile-content">
          <div class="payment-card-wrapper">
            <div class="table-title md-theme-block-head-color">Начислено к оплате</div>
            <table class="custom-dense-table accruals-table">
              <tbody>
              <tr
                v-for="(a,i) in accruals"
                :key="i"
              >
                <td @click="openPaymentDialog(a)">
                  <a
                    :href="a.receiptUrl"
                    :class="{'visibility-hidden': !a.receiptUrl}"
                    target="_blank"
                    @click.stop
                  ><md-icon style="margin-right: 5px">insert_drive_file</md-icon></a>
                  {{ a.title }}
                </td>
                <td
                  class="text-align-right"
                  @click="openPaymentDialog(a)"
                >
                  {{ a.amount | currency }}
                  <md-icon class="hidden-lg">chevron_right</md-icon>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="table-title md-theme-block-head-color">Платежи</div>
            <table class="custom-dense-table payments-table">
              <tbody>
              <tr
                v-for="(p,i) in payments"
                :key="i"
                @click="openReceiptDialog({ url: p.paymentUrl, isPDF: false})"
              >
                <td>
                  <span style="margin-right: 15px;">{{ p.date | date }}</span>
                  <span>{{ p.title }}</span>
                </td>
                <td class="text-align-right">
                  {{ p.amount | currency }}
                  <md-icon class="hidden-lg">chevron_right</md-icon>
                </td>
              </tr>
              </tbody>
            </table>
            <a
              v-if="hasPaymentsVariants"
              href="#"
              class="block-md"
              style="margin-left: 10px;"
              @click.prevent="openPaymentVariantsDialog"
            >
              Дополнительные способы оплаты
            </a>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <dialog-payment-variants
      v-if="showPaymentVariants"
      :showDialog="showPaymentVariants"
      @closeDialog="closePaymentVariantsDialog"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  DialogToPayment,
  DialogShowReceipt,
  DialogPaymentVariants
} from "@/apps/payments/components";

export default {
  name: "PaymentsPage",
  components: {
    DialogToPayment,
    DialogShowReceipt,
    DialogPaymentVariants
  },
  data() {
    return {
      showReceiptDialog: false,
      showPaymentDialog: false,
      showPaymentVariants: false,
      currentReceipt: null,
      currentPayment: null,
      isPDF: false
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(["getPayments", "getAccruals", "getPersonalAccountInfo"]),

    address() {
      if (this.getPersonalAccountInfo) {
        const street = this.getPersonalAccountInfo.apartment.thoroughfare;
        const premise = this.getPersonalAccountInfo.apartment.premise;
        const objectName = this.getPersonalAccountInfo.apartment.objectname;
        const apartment = this.getPersonalAccountInfo.apartment.number;

        return `${street} ${premise}, ${objectName} ${apartment}`;
      }
      return "";
    },

    payments() {
      return this.getPayments;
    },

    accruals() {
      return this.getAccruals;
    },

    hasPaymentsVariants() {
      if (this.getManageOrganizationInfo && 'services' in this.getManageOrganizationInfo) {
        return this.getManageOrganizationInfo.services.payments.paymentsList.length > 0;
      }
      return false;
    },
  },
  methods: {
    fetchData() {
      this.$store.dispatch("GET_PAYMENTS");
      this.$store.dispatch("GET_ACCRUALS");
    },

    openPaymentVariantsDialog() {
      this.showPaymentVariants = true;
    },

    closePaymentVariantsDialog() {
      this.showPaymentVariants = false;
    },

    openPaymentDialog(paymentObj) {
      this.currentPayment = paymentObj;
      this.showPaymentDialog = true;
    },

    closePaymentDialog() {
      this.showPaymentDialog = false;
      this.currentPayment = null;
    },

    openReceiptDialog({ url, isPDF }) {
      this.showReceiptDialog = true;
      this.isPDF = isPDF;
      this.currentReceipt = url;
    },

    closeReceiptDialog() {
      this.showReceiptDialog = false;
      this.type = null;
      this.currentReceipt = null;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/md/variables";

.payment-card {
  max-width: 785px;
  @media (max-width: 768px) {
    background-color: transparent !important;
    box-shadow: unset;
  }
  .md-card-content {
    padding: 25px 20px;
    @media (max-width: 768px) {
      padding: 0 !important;
    }
  }
  &-wrapper {
    padding: 0 10px;
    @media (max-width: 768px) {
      padding: 10px 0 0 0;
    }
  }
  .table-title {
    font-size: 17px;
    font-weight: 400;
    @media (max-width: 768px) {
      text-transform: uppercase;
      padding: 10px 8px;
    }
  }
  .accruals-table {
    margin-bottom: 20px;
    @media (max-width: 768px) {
     background-color: #ffffff;
    }
  }
  .payments-table {
    @media (max-width: 768px) {
      background-color: #ffffff;
    }
  }
  .custom-dense-table {
    tbody {
      tr {
        cursor: pointer;
      }
      td {
        @media (max-width: 768px) {
          padding: 10px 10px;
          white-space: nowrap;
          max-width: 200px;
          overflow-x: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
.block-md {
  display: block !important;
}
.table-payments {
  table > thead > tr > th {
    font-size: $font-size-h6;
    text-transform: uppercase;
  }
  table > thead > tr > .md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 5px;
    }
  }

  table > tbody > tr > .md-table-cell.td-name .md-table-cell-container {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  & .table-custom-header {
    text-transform: uppercase;
    font-weight: 400;
  }

  .td-value,
  .td-date,
  .td-name {
    font-size: 1.2em !important;
    line-height: 1.42857143;

    small {
      color: $gray-light;
      font-size: 0.75em;
      font-weight: $font-weight-light;
    }
  }
  .td-name {
    max-width: 30vw;
  }

  .td-value {
    width: 14%;
  }

  .td-date {
    width: 14%;
  }
}
</style>
